<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay middle" @click.self="$emit('close')">
      <div class="modal-window">
        <header class="modal-header">
          <div class="tit">{{$i18nUtil.trans("title.TodoDeleteModal.001","할 일 삭제 사유 등록")}}</div>
          <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        <div class="modal-content">
          <div class="txt1">
            {{$i18nUtil.trans("message.TodoDeleteModal.002","삭제된 정보는 완료된 할 일에서 이력으로 확인할 수 있습니다.")}}
            <div class="input-box">
              <input
                type="text"
                required
                :placeholder="$i18nUtil.trans('message.TodoDeleteModal.003','삭제사유를 등록해주세요.')"
                class="w100"
                v-model="delReason"
              />
              <button
                type="button"
                class="input-txt-del"
                @click="delReason = null"
              >
                입력 삭제
              </button>
              <div class="error" v-if="delReason == ''">
                {{ $i18nUtil.trans("message.TodoDeleteModal.004","사유를 입력해주세요.") }}
              </div>
            </div>
          </div>
        </div>
        <footer class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn_ty1" @click="todoDelete()">
              {{ $i18nUtil.trans("button.confirm","확인") }}
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import EventBus from "@/js/eventbus/eventBus";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      delReason: null,
      item: null
    };
  },
  mounted() {},
  created() {
    this.item = this.modalInfo.item;
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    todoDelete() {
      let self = this;
      if (self.delReason == null || self.delReason == "") {
        return;
      }
      /* 할 일삭제 */
      if (confirm(self.$i18nUtil.trans("AG055"))) { // "삭제하시겠습니까?"
        let reqData = {};
        reqData.url = "/api/copaper/todo/todoDelete";
        reqData.method = "post";
        reqData.params = {
          todoId: self.item.id,
          delReason: self.delReason
        };
        self.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
          setTimeout(function() {
            // self.updateBlock();
          }, 100);
          EventBus.$emit("getBoardTodoList", "getBoardTodoList");
          self.$emit("close");
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/TodoDeleteModal.vue